import { lazy } from 'react';

export const SettingsOrdersAsync = lazy(() => import('./SettingsOrders'));
